import { Box, Stack, Typography } from '@mui/material';
import ReportItem from '@/components/item/ReportItem';
import { usePdpProgressReport } from '@/api/hooks/usePdpProgressReport';
import EmptyState from '@/components/EmptyState';
import LoadingState from '@/components/LoadingState';
import { IconSvg } from '@/components/Icon';
const PDPProgressReport = () => {
  const texts = {
    emptyStateDesc: 'تاکنون گزارشی برای این طرح بارگذاری نشده است'
  };
  const {
    data,
    isLoading
  } = usePdpProgressReport();
  return isLoading ? <LoadingState data-sentry-element="LoadingState" data-sentry-component="PDPProgressReport" data-sentry-source-file="PDPProgressReport.tsx" /> : <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing_m_nudge)'
  }} data-sentry-element="Box" data-sentry-component="PDPProgressReport" data-sentry-source-file="PDPProgressReport.tsx">
      <Stack direction='row' gap={1} mb={3} data-sentry-element="Stack" data-sentry-source-file="PDPProgressReport.tsx">
        <IconSvg component='Documents' width='32' height='32' data-sentry-element="IconSvg" data-sentry-source-file="PDPProgressReport.tsx" />
        <Typography variant='headlineStrong__Wallfund' color='text.text' id='section-5' data-sentry-element="Typography" data-sentry-source-file="PDPProgressReport.tsx">
          گزارش پیشرفت
        </Typography>
      </Stack>
      {(data || [])?.length > 0 && !isLoading ? (data || []).map((report, idx) => {
      return <ReportItem key={'report_' + idx} data={report} index={idx} />;
    }) : <EmptyState desc={texts.emptyStateDesc} />}
    </Box>;
};
export default PDPProgressReport;